import { useEffect, useLayoutEffect } from "react"
import useInput from "../../../hooks/useInput"
import InputMessage from "../../ui/inputError"
import InputLabel from "../../ui/inputLabel"
import { strings } from "../../../assets/config/translations"
import './index.scss'

const CheckBox = (props) => {    
    const { ref,  bind, error, displayError, disabled} = useInput({...props, valueType: "checked", initialValue: false, ...props})
    const {register, deregister} = props 
    
    useLayoutEffect(() => {
        if (register){
            register(props.name, ref)
        }
        return () => {
            if (deregister){
                deregister(props.name)
            }
        }
    }, [])

    useEffect(() => {
        if (props.onRender) {
            props.onRender()
        }
    }, [bind.checked])

    return (
        <div className={`input input-checkbox ${props.className || ''} ${error && displayError ? 'error' : ''} ${disabled ? 'disabled' : ''}`}>
            <label className="input input-checkbox" tabIndex="0">
            <div className="group">
                <input 
                    id={props.name}
                    type="checkbox" 
                    {...bind}
                    {...props}

                />
                <i className="svg-checkbox" role="checkbox" aria-label="Example checkbox" aria-checked="false">
                <svg className="svg" width="24px" height="24px" viewBox="0 0 24 24">
                    <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                    <rect className="fill" height="20" rx="2" width="20" x="2" y="2"></rect>
                  <polyline className="stroke" points="7 13 10 16 17 8"></polyline>
                </g>
              </svg>
            
          </i>
          <span className="label-inline">{props.label}</span>
        </div>
        </label>
        {error &&
                <InputMessage displayError={displayError} error={strings[error] || error} />

        }
      </div>
    )

}

export default CheckBox;